/* tslint:disable */
/* eslint-disable */
/**
 * BusService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { CorporationInfo } from '../model';
/**
 * BillApiApiBillGetCorporationInfoGet - axios parameter creator
 * 
 * @param {string} [billCode] 
 * @param {string} [mac] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillApiApiBillGetCorporationInfoGetAxiosParamCreator (billCode?: string, mac?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Bill/GetCorporationInfo`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billCode !== undefined) {
        localVarQueryParameter['billCode'] = billCode;
    }

    if (mac !== undefined) {
        localVarQueryParameter['mac'] = mac;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BillApiApiBillGetCorportationInfoGet - axios parameter creator
 * 
 * @param {string} [billCode] 
 * @param {string} [mac] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BillApiApiBillGetCorportationInfoGetAxiosParamCreator (billCode?: string, mac?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Bill/GetCorportationInfo`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billCode !== undefined) {
        localVarQueryParameter['billCode'] = billCode;
    }

    if (mac !== undefined) {
        localVarQueryParameter['mac'] = mac;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiBillGetCorporationInfoGet operation in BillApi.
 * @export
 * @interface BillApiApiBillGetCorporationInfoGetRequest
 */
export interface BillApiApiBillGetCorporationInfoGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillApiApiBillGetCorporationInfoGet
     */
    readonly billCode?: string

    /**
     * 
     * @type {string}
     * @memberof BillApiApiBillGetCorporationInfoGet
     */
    readonly mac?: string
}

/**
 * Request parameters for apiBillGetCorportationInfoGet operation in BillApi.
 * @export
 * @interface BillApiApiBillGetCorportationInfoGetRequest
 */
export interface BillApiApiBillGetCorportationInfoGetRequest {
    /**
     * 
     * @type {string}
     * @memberof BillApiApiBillGetCorportationInfoGet
     */
    readonly billCode?: string

    /**
     * 
     * @type {string}
     * @memberof BillApiApiBillGetCorportationInfoGet
     */
    readonly mac?: string
}

/**
* 
* @param {BillApiApiBillGetCorporationInfoGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillApiApiBillGetCorporationInfoGet(requestParameters: BillApiApiBillGetCorporationInfoGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillApiApiBillGetCorporationInfoGetAxiosParamCreator(requestParameters.billCode, requestParameters.mac, options, configuration);
    const request: () => AxiosPromise<CorporationInfo> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BillApiApiBillGetCorportationInfoGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BillApiApiBillGetCorportationInfoGet(requestParameters: BillApiApiBillGetCorportationInfoGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BillApiApiBillGetCorportationInfoGetAxiosParamCreator(requestParameters.billCode, requestParameters.mac, options, configuration);
    const request: () => AxiosPromise<CorporationInfo> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
